import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1762391893515'
        class='icon'
        viewBox='0 0 1136 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='12845'
        width='200'
        height='200'
    >
        <path
            d='M729.165229 407.061917l-55.247554-54.937755a17.606931 17.606931 0 0 1 0-24.990483l112.973504-112.379722a17.813464 17.813464 0 0 1 25.093749 0l25.093749 24.964666a53.440392 53.440392 0 0 0 75.307064 0c20.808191-20.653291 20.808191-54.21489 0-74.919815L761.823246 14.933362a53.440392 53.440392 0 0 0-74.661648 0.645416 52.794976 52.794976 0 0 0-0.645416 74.274399l25.093749 24.964666a17.606931 17.606931 0 0 1 0 25.016299l-112.947687 112.379722a17.813464 17.813464 0 0 1-25.093749 0l-55.247555-54.937755a99.652131 99.652131 0 0 0-140.571465 0l-171.060886 170.208938a98.567833 98.567833 0 0 0-26.126414 93.86921l42.184348 167.859626a99.135799 99.135799 0 0 0 72.28652 71.950904l168.763208 41.951998a99.729581 99.729581 0 0 0 94.333908-25.971514l171.060887-170.208938a98.645283 98.645283 0 0 0 0-139.874416z'
            p-id='12846'
            fill='currentColor'
        ></path>
        <path
            d='M1090.417113 1023.6143H17.917505A17.710197 17.710197 0 0 1 0.000775 1006.472068c-0.283983-89.738551 61.211193-167.988709 148.806965-189.313233a195.58667 195.58667 0 0 1 219.880104 99.497232 142.791694 142.791694 0 0 1 143.359659-25.119566c47.838186-149.349114 197.935982-241.695143 353.610166-217.556609 155.648368 24.138534 270.377402 157.558797 270.274135 314.291463 0 39.189621-45.514691 35.342945-45.514691 35.342945z'
            p-id='12847'
            fill='currentColor'
        ></path>
    </svg>
)

export const ClearanceIcon = props => <Icon component={SVG} {...props} />
